import moment from "moment";
import { useEffect, useState } from "react";
import { getRemittanceTransactions } from "../../Apis/AnalyticsApiCalls/walletApis";
import { useAppDispatch, useAppSelector } from "../../Redux/app/hooks";
import { remittanceStatus } from "../../utils/filterSelect";
import { remittanceCols, remittanceExportCols } from "../../utils/tablecols";
import SearchOptions from "../Forms/SearchOptions";
import CustomTable from "../Reusables/Tables/CustomTable";
import { getRemittanceRows } from "./../../utils/TableRows/RemittanceRows";
import { ExportButton } from "../Reusables/Buttons/styles";

const RemittanceTable = () => {
  const { remittanceTransactions, gettingRemittanceTransactions } =
    useAppSelector((state) => state.wallet);
  const {
    Currency,
    NetworkChain,
    Status,
    TransactionHash,
    WalletAddress,
    RemittancePage,
    StartTimeStamp,
    EndTimeStamp,
    loading,
  } = useAppSelector((state) => state.form);
  const [showAddress, setShowAddress] = useState(false);
  const [selectedRow, setSelectedRow] = useState(0);
  const rows = getRemittanceRows(
    remittanceTransactions,
    showAddress,
    setShowAddress,
    selectedRow,
    setSelectedRow,
    loading
  );

  const reimittancedata = {
    columns: remittanceCols,
    rows,
  };

  useEffect(() => {
    const params = {
      Currency,
      NetworkChain,
      Status,
      TransactionHash,
      WalletAddress,
      Page: RemittancePage,
      PageSize: 20,
      StartTimeStamp: StartTimeStamp && moment(StartTimeStamp).unix(),
      EndTimeStamp: EndTimeStamp && moment(EndTimeStamp).unix(),
    };
    getRemittanceTransactions(params);
  }, [
    RemittancePage,
    Currency,
    NetworkChain,
    Status,
    TransactionHash,
    WalletAddress,
    RemittancePage,
    StartTimeStamp,
    EndTimeStamp,
  ]);

  const exportData = {
    headers: remittanceExportCols,
    data: rows,
  };

  return (
    <>
      <CustomTable
        data={reimittancedata}
        pageCount={remittanceTransactions?.totalPages}
        currentPage={remittanceTransactions?.currentPage}
        loading={gettingRemittanceTransactions}
        page="RemittancePage"
        title="Remittance Transactions"
        searchOptions={
          <SearchOptions
            recordDateRange={remittanceTransactions?.records}
            statusFilter={remittanceStatus}
          />
        }
        filter={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "10px",
            }}
          >
            <ExportButton
              data={exportData?.data}
              headers={exportData?.headers}
              filename={`Remittance-Transactions-page(${remittanceTransactions?.currentPage})`}
            >
              Export CSV
            </ExportButton>
          </div>
        }
        noRecordText="Remittance records not available"
      />
    </>
  );
};

export default RemittanceTable;
